import { useCallback } from 'react';

import {
  createSizeTypeMapping,
  getCustomerLinks,
  getSizeTypeMappings,
  getSizeTypeSightings,
  putCustomerLink,
  putCustomerLinks,
  updateSizeTypeMapping
} from 'services/fleet-files';
import { FleetFile } from 'types';

export const useFleetFiles = () => {
  /* an account's own link; still single-valued, because each account owns at most one */
  const getCustomerMappingById = useCallback(async (customerId: number): Promise<FleetFile.Customer | null> => {
    const headers: HeadersInit = new Headers();
    const token: string | null = localStorage.getItem('token');
    const url = new URL(`/api/fleet-files/customers/${customerId}`, window.location.origin);
    headers.set('Authorization', `Bearer ${token}`);
    try {
      const response = await fetch(url, { method: 'GET', headers });
      if (!response.ok) return null;
      const json = await response.json();
      if (typeof json === 'object') return json;
    } catch (e) {
      console.error(e);
    }
    return null;
  }, []);

  /*
   * The link functions resolve with the committed state or throw a `FleetLinkError`. They never
   * navigate and never announce success: the screen decides, because only the screen knows whether
   * it should stay put on failure (F09). They replace the per-location mapping read/write, which
   * assumed one account per code and navigated from inside the hook.
   */
  return {
    getCustomerMappingById,
    getCustomerLinks,
    putCustomerLinks,
    putCustomerLink,
    /* size-type crosswalk: same contract — committed data or a thrown `FleetLinkError` */
    getSizeTypeMappings,
    updateSizeTypeMapping,
    createSizeTypeMapping,
    getSizeTypeSightings
  };
};
